import WildixUIEvents from '../../../service/WildixUIEvents';

import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

export default class SettingsDialogItems extends Controls {
    namespace = 'settingsDialog';
    constructor() {
        super();
        this._items = [];
        this._dropdownItems = null;
        this._selectedDropdownIdx = 0;
    }

    init() {
        APP.wildix.eventEmitter.on(WildixUIEvents.OPEN_DEVICE_SELECT_DROPDOWN, this._handleDropdownOpen.bind(this));
        APP.wildix.eventEmitter.on(WildixUIEvents.CLOSE_DEVICE_SELECT_DROPDOWN, this._handleDropdownClose.bind(this));
        this._footerButtons = {};
        const ok = document.getElementById('modal-dialog-ok-button');
        const cancel = document.getElementById('modal-dialog-cancel-button');

        if (ok) {
            this._ok = new KeyboardFocusable(ok);
        }
        if (cancel) {
            this._cancel = new KeyboardFocusable(cancel);
        }

        this.collectElements();

        if (this._ok) {
            this._items.push(this._ok);
        }
    }

    destroy() {
        this._items = [];
        this._dropdownItems = null;
        this._selectedDropdownIdx = 0;
        this._footerButtons = null;
        APP.wildix.eventEmitter.off(WildixUIEvents.OPEN_DEVICE_SELECT_DROPDOWN, this._handleDropdownOpen.bind(this));
        APP.wildix.eventEmitter.off(WildixUIEvents.CLOSE_DEVICE_SELECT_DROPDOWN, this._handleDropdownClose.bind(this));
    }

    collectElements(itemsKey = '_items', selector = '.w-dropdown-value') {
        this[itemsKey] = [];
        const elements = document.querySelectorAll(selector);

        elements.forEach(elem => {
            this[itemsKey].push(
                new KeyboardFocusable(elem)
            );
        });
    }

    _handleDropdownOpen() {
        this.collectElements('_dropdownItems', '.w-dropdown-item');
        this._dropdownItems[0].focus();
    }

    _handleDropdownClose() {
        this._dropdownItems = null;
        this._selectedDropdownIdx = 0;
    }

    isPossibleUp() {
        return true;
    }

    isPossibleDown() {
        return true;
    }

    next() {
        if (this._cancel && this._currentIndex === this._items.length - 1) {
            this.unfocus();
            this._cancel.focus();
        }
    }

    prev() {
        if (this._cancel && this._currentIndex === this._items.length - 1) {
            this._cancel.unfocus();
            this._items[this._currentIndex].focus();
        }
    }

    enter() {
        if (!this._dropdownItems) {
            super.enter();
        } else {
            super.enter('_dropdownItems', '_selectedDropdownIdx');
        }
    }

    up() {
        if (!this._dropdownItems) {
            if (this._cancel && this._currentIndex === this._items.length - 1) {
                this._cancel.unfocus();
            }
            super.up();
        } else {
            super.up('_dropdownItems', '_selectedDropdownIdx');
        }
    }

    down() {
        if (!this._dropdownItems) {
            if (this._cancel && this._currentIndex === this._items.length - 1) {
                this._cancel.unfocus();
            }
            super.down();
        } else {
            super.down('_dropdownItems', '_selectedDropdownIdx');
        }
    }
}
